import RemoteAccessModal from './remote-access-modal.connect'

export default RemoteAccessModal
